var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEbayColorLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    viewBox: "3.5 28 83.7 33.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5AF02;}\n\t.st1{fill:#E53238;}\n\t.st2{fill:#0064D2;}\n\t.st3{fill:#86B817;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5,45.7c-3.8,0.1-6.2,0.8-6.2,3.3c0,1.6,1.3,3.4,4.6,3.4c4.4,0,6.7-2.4,6.7-6.3v-0.4L56.5,45.7L56.5,45.7z   M65.8,50.9l0.1,3.5h-3.9c-0.1-0.9-0.1-1.8-0.1-2.6c-2.1,2.6-4.6,3.3-8.1,3.3c-5.2,0-7.9-2.7-7.9-5.9c0-4.6,3.8-6.2,10.3-6.3  c1.8,0,3.8,0,5.4,0v-0.5c0-3.1-2-4.3-5.4-4.3c-2.5,0-4.4,1.1-4.6,2.8h-4.4c0.5-4.5,5.2-5.6,9.3-5.6c5,0,9.2,1.8,9.2,7L65.8,50.9  L65.8,50.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,43.5c-0.2-3.9-3-5.4-6-5.4c-3.3,0-5.9,1.7-6.3,5.4H20.2z M7.8,46.3c0.2,3.8,2.8,6.1,6.5,6.1  c2.5,0,4.7-1,5.5-3.2H24c-0.8,4.5-5.6,6-9.7,6c-7.5,0-10.8-4.1-10.8-9.7c0-6.1,3.4-10.1,10.9-10.1c5.9,0,10.2,3.1,10.2,9.9v1.1  L7.8,46.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.4,52.3c3.9,0,6.6-2.8,6.6-7s-2.7-7-6.6-7c-3.9,0-6.6,2.8-6.6,7S31.5,52.3,35.4,52.3z M24.6,28h4.2v10.5  c2.1-2.5,4.9-3.2,7.7-3.2c4.7,0,9.9,3.2,9.9,10c0,5.7-4.1,9.9-9.9,9.9c-3.1,0-5.9-1.1-7.7-3.3c0,0.9,0,1.7-0.1,2.6h-4.1l0.1-4.3  L24.6,28L24.6,28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.2,36l-13,25.5h-4.7l3.7-7.1L63.5,36h4.9l7.2,14.4L82.7,36L87.2,36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbayColorLogoSmall);
export default __webpack_public_path__ + "static/media/ebay-color-logo-small.da1463a53315d988759c7240acd02ff7.svg";
export { ForwardRef as ReactComponent };